(function () {
  angular
    .module('app')
    .component('clinicPatientAdmissionDetailsPatientAdmissionTimelineBodyComponent', {
      require: {
        container: '^clinicPatientAdmissionDetailsPatientAdmissionTimelineBodyComponent'
      },
      templateUrl: require('/App/clinic/views/patient/admissionDetails/patientAdmissionTimelineBody/patientAdmissionTimelineBody.component.html'),
      controller: [
        '$state', '$uibModal', '$timeout', 'abp.services.app.inpatientGuaranteeLetter', 'abp.services.app.hospitalPanelServiceRequest', 'abp.services.app.serviceRequestQuery', 'moment',
        controller
      ],
      controllerAs: 'vm',
      bindings: {
        guaranteeLetterNumber: '<',
        timeZoneId: '='
      }
    });

  function controller($state, $modal, $timeout, inpatientGuaranteeLetterSvc, hospitalPanelServiceRequestSvc, serviceRequestQuerySvc, moment) {
    var vm = this;
    vm.loading = 0;

    // HM-11001: when the user detoured here from the FGL page (HM-11000 set this
    // intent in sessionStorage), prompt them back to the Final GL once every
    // medical query has been answered. The key is built in init(), once the
    // guaranteeLetterNumber binding is available.

    var fglIntentKey = null;
    vm.openTab = openTab;
    vm.printGlButton = printGlButton;
    vm.finalButton = finalButton;
    vm.adjustmentButton = adjustmentButton;
    vm.topUpAddOnButton = topUpAddOnButton;
    vm.cancelGlButton = cancelGlButton;
    vm.activeTab = 'patientAdmissionTimeline';
    vm.newQueriesCount = 0;
    vm.checkInButton = checkInButton;
    vm.guaranteeLetterDetails = null;
    vm.canUseButton = true;

    function init() {
      // Hide all elements upon initialisation

      $('.tabcontent').css('display', 'none');

      // Display patient admission timeline by default

      $('#patientAdmissionTimeline').css('display', 'block');

      getServiceRequestDetailsForTimelineButtons();

      vm.loading++
      inpatientGuaranteeLetterSvc.getInpatientGuaranteeLetterDetail({
        id: vm.guaranteeLetterNumber
      }).success(function (data) {
        vm.guaranteeLetterDetails = data;
      }).finally(function (e) {
        vm.loading--;
      });

      // HM-11001: intent-aware return to FGL.

      fglIntentKey = 'fglIntent:' + vm.guaranteeLetterNumber;
      handleFglIntent();
    };

    function openTab(evt, tabname) {
      // Get all elements with class="tabcontent" and hide them

      $('.tabcontent').css('display', 'none');

      // Get all elements with class="tablinks" and remove the class "active"

      $('.tablinks').removeClass('active');

      // Show the current tab, and add an "active" class to the link that opened the tab

      $('#' + tabname).css('display', 'block');
      evt.currentTarget.className += ' active';

      vm.activeTab = tabname;
    }

    function adjustmentButton() {
      if (vm.details.adjustmentEnabled)
        $state.go('clinic.adjustmentRequest', {
          letterNumber: vm.guaranteeLetterNumber
        })
    };

    function topUpAddOnButton() {
      if (vm.details.topUpEnabled && !vm.details.isPendingApproval) {
        var modal = $modal.open({
          templateUrl: require('/App/clinic/views/patient/admissionDetails/patientAdmissionTimelineBody/topUpRequestModal/topUpRequestModal.html'),
          controller: "clinic.views.hospital.topUpRequestModal as vm",
          backdrop: "static",
          size: 's',
        });
        modal.result.then(function (requestType) {
          $state.go('clinic.topUpRequest', {
            requestType: requestType,
            letterNumber: vm.guaranteeLetterNumber
          });
        });
      };
    };

    function printGlButton() {
      if (vm.details.printGlEnabled && !vm.details.isPendingApproval)
        window.open(vm.details.printGlUrl, "_blank");
    }

    function checkInButton(guaranteeLetterDetails) {
      var today = moment().format('YYYY-MM-DD');
      var scheduledTime = moment(guaranteeLetterDetails.guaranteeLetter.admissionTime).format('YYYY-MM-DD');
      if (!scheduledTime)
        return;

      if (scheduledTime === today) {
        swal({
          title: App.localize('ConfirmAdmission'),
          text: App.localize('ConfirmAdmissionNarrative'),
          confirmButtonColor: '#1ab394',
          confirmButtonText: App.localize('Yes'),
          cancelButtonText: App.localize('No'),
          showCancelButton: true,
          closeOnConfirm: false,
        }, function (isConfirm) {
          if (isConfirm) {
            checkIn('', guaranteeLetterDetails);
          }
          swal.close();
        });
      } else {
        $modal.open({
          templateUrl: require('/App/clinic/views/hospital/patient/admission/admission.modal.html'),
          controller: 'clinic.views.hospital.patient.admission as vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            scheduleDate: function () {
              return guaranteeLetterDetails.guaranteeLetter.admissionTime;
            },
            expiryDate: function () {
              return guaranteeLetterDetails.guaranteeLetter.expiredTime;
            },
            letterNumber: function () {
              return guaranteeLetterDetails.guaranteeLetter.letterNumber;
            }
          }
        }).result.then(function (data) {
          if (data.isCheckIn)
            checkIn(data, guaranteeLetterDetails);
        });
      }
    }

    function checkIn(data, guaranteeLetterDetails) {
      vm.loading++;
      hospitalPanelServiceRequestSvc.checkIn({
        employeeId: guaranteeLetterDetails.patient.id,
        guaranteeLetterNumber: guaranteeLetterDetails.guaranteeLetter.letterNumber,
        serviceType: guaranteeLetterDetails.request.type,
        remarks: data.reason,
        actualAdmissionDate: data.actualAdmissionDate,
        newAttachments: data.newAttachments
      }).success(function (data) {
        if (data.printUrl != "") {
          abp.notify.info(App.localize('PatientXCheckedIn', guaranteeLetterDetails.patient.name));
          window.open(data.printUrl);
          $state.go('clinic.inpatientDashboard')
        } else {
          if (data.isEarlyCheckIn)
            abp.notify.info(App.localize('EarlyCheckInRequestSubmitted'));
          else
            abp.notify.info(App.localize('LateCheckInRequestSubmitted'));
          vm.refreshFunction();
        }
      }).finally(function () {
        vm.loading--;
      });
    }

    function finalButton() {
      /* If TopUp/AddOn reuqest exists, prompt user for confirmation to cancel TopUp/AddOn request
       * Request status === 1 (Pending Approval), Request type === 4 (AddOn)
       */

      if (vm.details.latestServiceRequestStatus === 1 && vm.details.latestServiceRequestType === 4 && !vm.details.isPendingApproval) {
        swal({
          title: App.localize('ConfirmCancelTopUpAddOnRequest'),
          text: App.localize('ConfirmCancelTopUpAddOnRequestNarrative'),
          confirmButtonColor: '#1ab394',
          confirmButtonText: App.localize('CancelTopUpAddOnRequest'),
          cancelButtonText: App.localize('No'),
          showCancelButton: true,
          closeOnConfirm: false,
        }, function (isConfirm) {
          if (isConfirm) {
            var input = {
              letterNumber: vm.guaranteeLetterNumber,
              cancellationReason: App.localize('CancelTopUpAddOnRequest')
            };

            vm.loading++;
            hospitalPanelServiceRequestSvc.cancelGuaranteeLetterServiceRequest(input)
              .success(function (data) {
                abp.notify.success("Top-Up/Add-On request cancelled");
              })
              .finally(function (data) {
                vm.loading--;
                $state.go('clinic.fglRequest', {
                  letterNumber: vm.guaranteeLetterNumber
                })
              });
          }
          swal.close();
        });
      } else if (vm.details.finalEnabled && !vm.details.isPendingApproval) {
        $state.go('clinic.fglRequest', {
          letterNumber: vm.guaranteeLetterNumber
        })
      }
    }

    function cancelGlButton() {
      $modal.open({
        templateUrl: require('/App/clinic/views/hospital/common/cancellationModal/cancel.modal.html'),
        controller: 'clinic.views.hospital.common.cancelModal as vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          letterRequestType: function () {
            return 2; // Default to Initial type to show "Cancel guarantee letter" title and description.
          },
          letterStatus: function () {
            return vm.details.letterStatus;
          }
        }
      }).result.then(function (cancellationReason) {
        if (cancellationReason) {
          var input = {
            letterNumber: vm.guaranteeLetterNumber,
            cancellationReason: cancellationReason
          };

          vm.loading++;

          hospitalPanelServiceRequestSvc.cancelGuaranteeLetterServiceRequest(input)
            .success(function (data) {
              abp.notify.success("Cancelled");
            })
            .finally(function (data) {
              vm.loading--;
              goToDashboard();
            });
        }
      });
    }

    function goToDashboard() {
      $state.go('clinic.inpatientDashboard');
    }

    function getServiceRequestDetailsForTimelineButtons() {
      vm.loading++;
      inpatientGuaranteeLetterSvc.getServiceRequestDetailsForTimelineButtons({
        id: vm.guaranteeLetterNumber
      }).success(function (data) {
        vm.details = data;
      }).finally(function (e) {
        vm.loading--;
      });
    }

    /* HM-11001 Intent-aware return to FGL */

    function handleFglIntent() {
      // Only act when the user detoured here from the FGL page. Organic visits
      // have no intent set and are unaffected.

      if (!getFglIntent())
        return;

      vm.loading++;
      serviceRequestQuerySvc.getQueries({
        guaranteeLetterNumber: vm.guaranteeLetterNumber,
        skipCount: 0,
        maxResultCount: 1
      }).success(function (data) {
        // newQueriesCount is the clinic-side count of queries still awaiting a
        // reply (i.e. Pending). Zero means every medical query has been answered.

        if (data.newQueriesCount > 0) {
          // Pending queries remain: surface the Queries tab so the user can
          // answer them. Keep the intent so the return prompt fires once they
          // are all done.

          showQueriesTab();
        } else {
          promptReturnToFgl();
        }
      }).finally(function () {
        vm.loading--;
      });
    }

    function promptReturnToFgl() {
      abp.message.confirm(
        App.localize('AllMedicalQueriesAnsweredReturnToFgl', vm.guaranteeLetterNumber),
        null,
        function (isConfirmed) {
          // Either choice consumes the intent.

          clearFglIntent();

          if (isConfirmed) {
            // abp.message.confirm resolves outside the Angular digest.

            $timeout(function () {
              $state.go('clinic.fglRequest', { letterNumber: vm.guaranteeLetterNumber });
            });
          }
        },
        {
          confirmButtonText: App.localize('GoToFgl'),
          cancelButtonText: App.localize('Stay')
        }
      );
    }

    function showQueriesTab() {
      $('.tabcontent').css('display', 'none');
      $('.tablinks').removeClass('active');
      $('#patientAdmissionQueries').css('display', 'block');
      $('#patientAdmissionQueriesTabBtn').addClass('active');
      vm.activeTab = 'patientAdmissionQueries';
    }

    function getFglIntent() {
      try {
        return sessionStorage.getItem(fglIntentKey);
      } catch (e) {
        // sessionStorage unavailable (private mode / disabled) — treat as no intent.

        return null;
      }
    }

    function clearFglIntent() {
      try {
        sessionStorage.removeItem(fglIntentKey);
      } catch (e) {
        // sessionStorage unavailable — non-fatal.
      }
    }

    init();
  }
})();
